// ─────────────────────────────────────────────────────────────────────────────
// dp-custom.js
// Allgemeine Anpassungen für alle Seiten.
//
// Ausgelagert:
//   • Kalender (gemeinsam)        → dp-calendar.js
//   • Collection-Filter/Ajaxinate → dp-collection-filters.js
//   • Termin-Auswahl Produktseite → dp-variant-datepicker.js
// ─────────────────────────────────────────────────────────────────────────────
(function () {
  'use strict';

  // ─── 1. Farb-Logik ───────────────────────────────────────────────────────
  (function () {
    const root = document.documentElement;
    const url = window.location.href.toLowerCase();
    const colors = {
      test:      '#8800ff',
      afterwork: '#2E4A1C',
      techno:    '#0D4075',
      rnb:       '#A82117',
      brunch:    '#FF7538'
    };
    const matched = Object.keys(colors).some(key => {
      if (url.includes(key)) {
        root.style.setProperty('--collection-button-bg-color', colors[key]);
        return true;
      }
      return false;
    });
    if (!matched) root.style.setProperty('--collection-button-bg-color', 'var(--color-text)');
  })();


  // ─── 2. Newsletter-Formular ──────────────────────────────────────────────
  function addNewsletterClass(attemptsLeft) {
    if (attemptsLeft === undefined) attemptsLeft = 20;
    const form = document.querySelector('form[id*="omnisend-form"][id*="submit-form"]');
    if (form) {
      form.classList.add('newsletter-formular');
      return;
    }
    if (attemptsLeft <= 0) return;
    setTimeout(() => addNewsletterClass(attemptsLeft - 1), 1000);
  }


  // ─── 3. Produktbeschreibung: "mehr lesen" ────────────────────────────────
  function initReadMore() {
    document.querySelectorAll('.product-info__description .prose').forEach(function (prose) {
      if (prose.dataset.readmore) return;
      prose.dataset.readmore = 'true';
      prose.classList.add('dp-readmore');

      if (prose.scrollHeight <= prose.clientHeight + 2) {
        prose.classList.remove('dp-readmore');
        return;
      }

      const button = document.createElement('button');
      button.type = 'button';
      button.className = 'dp-readmore__toggle';
      button.setAttribute('aria-expanded', 'false');
      button.textContent = '… mehr lesen';

      button.addEventListener('click', function () {
        const expanded = prose.classList.toggle('is-expanded');
        button.setAttribute('aria-expanded', expanded);
        button.textContent = expanded ? 'weniger anzeigen' : '… mehr lesen';
      });

      prose.after(button);
    });
  }


  // ─── 4. Bindestrich in Collection-Card-Titeln nur auf Desktop entfernen ──
  const dpMq = window.matchMedia('(min-width: 1000px)');

  function dpUpdateCardTitles() {
    document.querySelectorAll('.collection-card-title').forEach(function (el) {
      if (!el.dataset.originalText) el.dataset.originalText = el.textContent;
      el.textContent = dpMq.matches
        ? el.dataset.originalText.replace(/-/g, '')
        : el.dataset.originalText;
    });
  }


  // ─── 5. Start ────────────────────────────────────────────────────────────
  function start() {
    setTimeout(() => addNewsletterClass(), 2000);
    initReadMore();
    dpUpdateCardTitles();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
  dpMq.addEventListener('change', dpUpdateCardTitles);
})();